//#region src/schema/localization/locales/de.ts
var e = {
	schema: {
		noAllowedValues: "Keine Werte erfüllen diese Enum-Bedingung.",
		example: "Beispiel",
		examples: "Beispiele",
		default: "Standard",
		schema: "Schema",
		emptyObject: "Leeres Objekt",
		showAdditionalProperties: "Zusätzliche Eigenschaften anzeigen",
		showOneMoreProperty: "1 weitere Eigenschaft anzeigen",
		showMoreProperties: "{count} weitere Eigenschaften anzeigen",
		forName: "für {name}",
		showSchemaDetails: "Schema-Details anzeigen",
		oneOf: "Eines von",
		anyOf: "Beliebiges von",
		allOf: "Alle von",
		not: "Nicht",
		unknownType: "unbekannter Typ",
		propertyCount: "Eigenschaften: {count}",
		headerCount: "Header: {count}",
		recursiveReference: "Rekursiver Verweis auf {name}",
		recursive: "rekursiv",
		additionalProperties: "zusätzliche Eigenschaften",
		const: "Konstante",
		deprecated: "veraltet",
		discriminator: "Diskriminator",
		enum: "enum",
		format: "Format",
		greaterThan: "größer als",
		keys: "Schlüssel",
		lessThan: "kleiner als",
		max: "max.",
		min: "min.",
		maxLength: "max. Länge",
		minLength: "min. Länge",
		multipleOf: "Vielfaches von",
		nullable: "nullable",
		propertyNames: "Eigenschaftsnamen",
		pattern: "Muster",
		copyPattern: "Muster kopieren",
		readOnly: "nur lesbar",
		required: "erforderlich",
		hideValues: "Werte ausblenden",
		showAllValues: "Alle Werte anzeigen",
		type: "Typ",
		unique: "eindeutig",
		values: "Werte",
		writeOnly: "nur schreibbar"
	},
	common: {
		copyDefault: "Standardwert kopieren",
		copyExample: "Beispielwert kopieren"
	},
	actions: { copyLinkTo: "Link zu {name} kopieren" }
};
//#endregion
export { e as de };

//# sourceMappingURL=de.js.map